module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/library/modules/_add-to-unscopables.js
// module id = 438
// module chunks = 0 1